<template>
  <div class="shortcut-grid" role="list">
    <component
      v-for="shortcut in shortcuts"
      :key="shortcut.id"
      :is="tileComponent(shortcut)"
      :to="shortcut.route ? { name: shortcut.route } : undefined"
      :href="shortcut.href || undefined"
      :target="shortcut.external ? '_blank' : undefined"
      :rel="shortcut.external ? 'noopener noreferrer' : undefined"
      type="button"
      class="shortcut-tile"
      role="listitem"
      @click="onClick(shortcut, $event)"
    >
      <app-icon
        :icon="shortcut.icon"
        :gradient="shortcut.gradient"
        size="lg"
      />
      <span class="shortcut-tile__label">{{ shortcut.label }}</span>
    </component>
  </div>
</template>

<script>
import AppIcon from '@/components/layout/AppIcon.vue';

export default {
  name: 'HomeShortcutGrid',
  components: {
    AppIcon,
  },
  props: {
    shortcuts: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    tileComponent(shortcut) {
      if (shortcut.href) {
        return 'a';
      }

      if (shortcut.route) {
        return 'router-link';
      }

      return 'button';
    },
    onClick(shortcut, event) {
      if (shortcut.href) {
        return;
      }

      if (!shortcut.action) {
        return;
      }

      event.preventDefault();
      this.$emit('action', shortcut.action);
    },
  },
};
</script>

<style scoped>
.shortcut-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(96px, 1fr));
  gap: var(--spacing-xl) var(--spacing-md);
  justify-items: center;
  max-width: 720px;
  margin: 0 auto;
  padding: var(--spacing-md) 0 var(--spacing-xl);
}

.shortcut-tile {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 100%;
  max-width: 96px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  text-decoration: none;
  color: inherit;
  font: inherit;
  transition: transform 0.15s ease;
}

.shortcut-tile:hover,
.shortcut-tile:focus-visible {
  transform: translateY(-2px);
  outline: none;
}

.shortcut-tile:hover :deep(.app-icon),
.shortcut-tile:focus-visible :deep(.app-icon) {
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.22);
}

.shortcut-tile__label {
  font-size: 0.72rem;
  font-weight: 500;
  color: var(--text-primary);
  text-align: center;
  line-height: 1.25;
  word-break: break-word;
}

@media (min-width: 768px) {
  .shortcut-grid {
    grid-template-columns: repeat(4, 96px);
    justify-content: center;
    gap: var(--spacing-xl);
  }
}
</style>
